import { Database } from '@databases/model/database';
import { FieldType } from '@databases/model/field';
import { Value } from '@databases/model/value';
import { DefaultRootState } from '@databases/redux';

import { convertType, getInitialValue } from '../../../database/field-types';
import { valueToCollabJSON } from '../../collab/convert-to-collab';
import {
  fieldToDatabase,
  fieldTypeMap,
  valueToDatabase,
} from '../../collab/convert-to-database';

export function getConvertedValue(
  db: Database,
  fieldId: string,
  value: Value<FieldType> | undefined,
  type: FieldType,
  state: DefaultRootState | undefined
) {
  const defaultValue = db.defaultEntry.getValue(fieldId);

  let reduxValue;

  if (value) {
    reduxValue = valueToDatabase(value.toJSON());
  } else if (defaultValue) {
    reduxValue = valueToDatabase(defaultValue.toJSON());
  } else {
    reduxValue = getInitialValue(fieldTypeMap[type]);
  }

  const convertedType = convertType(
    {
      field: fieldToDatabase(fieldId, db.fieldsById[fieldId].toJSON()),
      value: reduxValue,
    },
    fieldTypeMap[type],
    state
  );

  return valueToCollabJSON(convertedType, {});
}
